export default class BaseCtrl{
    constructor(){
        this.theme = 'yemast'
    }
}